module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n<button kendoButton [primary]=\"config.primary\" [iconClass]=\"config.icon\">{{ config.contentKey | translate }}</button>"


//////////////////
// WEBPACK FOOTER
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/button/button.component.html
// module id = ../../../../../src/app/shared/components/button/button.component.html
// module chunks = main